// extracted by mini-css-extract-plugin
export default {"header":"AlertSection_header__ciEuS","alerts":"AlertSection_alerts__M0aLR"};